export var loadVODPlayer = function () {
    return import(
    /* webpackChunkName: "widget/vod-player" */
    '@wix/wix-vod-shared/dist/src/widget/vod-player/vod-player');
};
